import { Environment } from "app/data/model/app/env.model";

export const environment: Environment = {
  production: true,
  restBaseUri: "",
  env: "PROD",
  accountServiceUri: "https://be-mc-stage.konzept-weiss.de/",
  accountServiceKey:
    "f4A7WYBqJyjXRaRorXSf8RGbv3p7o3cCxa7R5M7wd58IcH2i1ahqV13Hogb5cwfvL4S35iSdmDCjKBt24alTMJRdv55Q6F04Nq2Z0IsqycHctCKCmJaXWbyszaLzNh5d",
  enableThemeSetting: false,
  consumeKey: "",
  secretKey: "",
  userLoginForm: {
    user: "",
    password: "",
  },
};
